import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 3,
  },
  shadowOpacity: 0.13,
  shadowRadius: 2.62,

  elevation: 4,
};

export default ({colors, typography}: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: colors.white,
      },
      navigationBackground: {
        backgroundColor: colors.white,
      },

      listContainer: {
        flex: 1,
        marginTop: Platform.OS === 'web' ? 20 : 0,
        marginHorizontal: Platform.OS === 'web' ? 30 : 0,
        marginBottom: 30,
        ...shadow,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
